import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72244696"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "card-top",
  class: "p-10 card",
  style: {"background-image":"url('/media/shape/survey-plus-background-top.png')","background-repeat":"no-repeat","background-size":"cover","background-position-x":"100%"}
}
const _hoisted_2 = { class: "fw-bold display-6 d-inline-block text-dark-blue" }
const _hoisted_3 = { class: "fs-6 text-start mt-2" }
const _hoisted_4 = { class: "fw-bolder" }
const _hoisted_5 = {
  key: 0,
  class: "card-body row"
}
const _hoisted_6 = { class: "container-timeline col-3 pe-0" }
const _hoisted_7 = { class: "timeline-label" }
const _hoisted_8 = {
  key: 0,
  class: "timeline-badge",
  style: {"width":"2.75rem","height":"2.75rem","margin-top":"23px !important","margin-left":"-1.2rem !important","border":"3px solid white !important"}
}
const _hoisted_9 = {
  key: 1,
  class: "timeline-badge",
  style: {"width":"2.75rem","height":"2.75rem","margin-top":"23px !important","margin-left":"-1.2rem !important","border":"3px solid #909399 !important"}
}
const _hoisted_10 = {
  class: "tab-content col-9 border border-dark-blue border-3 rounded p-15 bg-white",
  id: "myTabContent"
}
const _hoisted_11 = ["id", "innerHTML"]
const _hoisted_12 = { style: {"display":"flex","justify-content":"flex-end","margin":"40px 0"} }
const _hoisted_13 = ["alt"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M14.5 3H2.5C2.23478 3 1.98043 3.10536 1.79289 3.29289C1.60536 3.48043 1.5 3.73478 1.5 4V12C1.5 12.2652 1.60536 12.5196 1.79289 12.7071C1.98043 12.8946 2.23478 13 2.5 13H14.5C14.7652 13 15.0196 12.8946 15.2071 12.7071C15.3946 12.5196 15.5 12.2652 15.5 12V4C15.5 3.73478 15.3946 3.48043 15.2071 3.29289C15.0196 3.10536 14.7652 3 14.5 3ZM13.4 4L8.5 7.39L3.6 4H13.4ZM2.5 12V4.455L8.215 8.41C8.2987 8.46806 8.39813 8.49918 8.5 8.49918C8.60187 8.49918 8.7013 8.46806 8.785 8.41L14.5 4.455V12H2.5Z",
  fill: "white"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "p-10" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "fw-bold display-6 d-inline-block text-dark-blue" }
const _hoisted_19 = { class: "fs-6 text-start mt-2" }
const _hoisted_20 = { class: "fw-bolder" }
const _hoisted_21 = { class: "mt-10 fs-3 d-flex align-items-center" }
const _hoisted_22 = { class: "me-5" }
const _hoisted_23 = { class: "border rounded-circle shadow p-3 bg-white text-center w-45px h-45px" }
const _hoisted_24 = { class: "row mt-10 container-radial-bar" }
const _hoisted_25 = { class: "container-radial-bar-charts col-8" }
const _hoisted_26 = { class: "row w-100" }
const _hoisted_27 = { class: "col-7 d-flex justify-content-between flex-column" }
const _hoisted_28 = {
  key: 0,
  class: "card p-5 fs-4"
}
const _hoisted_29 = { class: "text-dark-blue" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-dark-blue me-1" }, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-custom-blue me-1" }, null, -1))
const _hoisted_32 = { class: "card text-center py-3 px-8" }
const _hoisted_33 = { class: "col-5 d-flex justify-content-between flex-column" }
const _hoisted_34 = {
  key: 0,
  class: "card p-5 fs-4"
}
const _hoisted_35 = { class: "text-dark-blue" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-dark-blue me-1" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-custom-blue me-1" }, null, -1))
const _hoisted_38 = { class: "card text-center py-3 px-8" }
const _hoisted_39 = { class: "how-to-read-the-data-container row card mt-10" }
const _hoisted_40 = { class: "px-10 py-10 rounded-5" }
const _hoisted_41 = { class: "graph1-title text-dark-blue" }
const _hoisted_42 = ["innerHTML"]
const _hoisted_43 = { class: "container-compare-your-results-top col-4 mb-10" }
const _hoisted_44 = {
  key: 0,
  class: "p-10 card"
}
const _hoisted_45 = { class: "fs-3 fw-bold form-label mb-3" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "fw-bold form-label mb-1" }
const _hoisted_48 = ["label"]
const _hoisted_49 = ["value", "label"]
const _hoisted_50 = { class: "mb-3" }
const _hoisted_51 = { class: "fw-bold form-label mb-1" }
const _hoisted_52 = ["label"]
const _hoisted_53 = ["value", "label"]
const _hoisted_54 = { class: "mb-3" }
const _hoisted_55 = { class: "fw-bold form-label mb-1" }
const _hoisted_56 = ["label"]
const _hoisted_57 = ["value", "label"]
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = { class: "fw-bold form-label mb-1" }
const _hoisted_60 = ["label"]
const _hoisted_61 = ["label"]
const _hoisted_62 = ["label"]
const _hoisted_63 = { class: "mb-3" }
const _hoisted_64 = { class: "fw-bold form-label mb-1" }
const _hoisted_65 = ["label"]
const _hoisted_66 = ["label"]
const _hoisted_67 = ["label"]
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = { class: "fw-bold form-label mb-1" }
const _hoisted_70 = ["label"]
const _hoisted_71 = ["label"]
const _hoisted_72 = ["label"]
const _hoisted_73 = ["label"]
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pagebreak" }, null, -1))
const _hoisted_75 = {
  id: "card-bottom",
  class: "mt-10 p-10 card",
  style: {"background-image":"url('/media/shape/survey-plus-background-bottom.png')","background-repeat":"no-repeat","background-size":"cover","background-position-x":"100%"}
}
const _hoisted_76 = { class: "fw-bold display-6 d-inline-block text-dark-blue" }
const _hoisted_77 = { class: "fs-6 text-start mt-2" }
const _hoisted_78 = { class: "fw-bolder" }
const _hoisted_79 = { class: "mt-10 fs-3 d-flex align-items-center" }
const _hoisted_80 = { class: "me-5" }
const _hoisted_81 = { class: "border rounded-circle shadow p-3 bg-white text-center w-45px h-45px" }
const _hoisted_82 = { class: "row mt-10" }
const _hoisted_83 = { class: "container-six-diverseties col-8 p-10" }
const _hoisted_84 = { class: "card mb-20 shadow px-5" }
const _hoisted_85 = {
  key: 0,
  class: "table table-row-gray-100 align-middle gs-0 gy-3 text-center"
}
const _hoisted_86 = { class: "fw-bolder" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "" }, null, -1))
const _hoisted_88 = { class: "" }
const _hoisted_89 = { class: "" }
const _hoisted_90 = { class: "" }
const _hoisted_91 = { class: "" }
const _hoisted_92 = { class: "" }
const _hoisted_93 = { class: "" }
const _hoisted_94 = { class: "fs-2 text-gray-700" }
const _hoisted_95 = { class: "text-start pl-2 fw-bold fs-6 text-dark" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-dark-blue me-1" }, null, -1))
const _hoisted_97 = { class: "text-start pl-2 fw-bold fs-6 text-dark" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle text-custom-blue me-1" }, null, -1))
const _hoisted_99 = { class: "container-compare-your-results-bottom col-4 p-10" }
const _hoisted_100 = { class: "mb-10 p-10 shadow card" }
const _hoisted_101 = { key: 0 }
const _hoisted_102 = { class: "fs-3 fw-bold form-label mb-3" }
const _hoisted_103 = { class: "mb-3" }
const _hoisted_104 = { class: "fw-bold form-label mb-1" }
const _hoisted_105 = ["label"]
const _hoisted_106 = ["value", "label"]
const _hoisted_107 = { class: "mb-3" }
const _hoisted_108 = { class: "fw-bold form-label mb-1" }
const _hoisted_109 = ["label"]
const _hoisted_110 = ["value", "label"]
const _hoisted_111 = { class: "mb-3" }
const _hoisted_112 = { class: "fw-bold form-label mb-1" }
const _hoisted_113 = ["label"]
const _hoisted_114 = ["value", "label"]
const _hoisted_115 = { class: "mb-3" }
const _hoisted_116 = { class: "fw-bold form-label mb-1" }
const _hoisted_117 = ["label"]
const _hoisted_118 = ["label"]
const _hoisted_119 = ["label"]
const _hoisted_120 = { class: "mb-3" }
const _hoisted_121 = { class: "fw-bold form-label mb-1" }
const _hoisted_122 = ["label"]
const _hoisted_123 = ["label"]
const _hoisted_124 = ["label"]
const _hoisted_125 = { class: "mb-3" }
const _hoisted_126 = { class: "fw-bold form-label mb-1" }
const _hoisted_127 = ["label"]
const _hoisted_128 = ["label"]
const _hoisted_129 = ["label"]
const _hoisted_130 = ["label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.translate("TITLE_SURVEY_PLUS_OVERALL_RESULT")) + " ", 1),
          _createElementVNode("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.translate("TITLE_YEAR")) + " ", 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.current_yearly_period), 1)
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankings, (ranking, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["timeline-item", { 'active bg-dark-blue text-white': ranking.is_active }]),
                      key: index
                    }, [
                      (ranking.is_active)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9)),
                      _createElementVNode("div", {
                        class: _normalizeClass(["timeline-content fw-mormal fs-1 ps-10 py-8", ranking.is_active ? 'text-white' : 'text-gray-700'])
                      }, _toDisplayString(_ctx.formatRankingLabel(ranking["attributes"][_ctx.translateKey("label")])), 3)
                    ], 2))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rankings, (ranking, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(
              ranking.is_active
                ? 'show active tab-pane fade text-dark-blue fs-4'
                : 'tab-pane fade'
            ),
                    id: `kt_vtab_pane_${ranking.id}`,
                    role: "tabpanel",
                    key: index,
                    innerHTML: 
              ranking['attributes'][_ctx.translateKey('rich_descr')]
                ? ranking['attributes'][_ctx.translateKey('rich_descr')]
                : _ctx.translate('TEXT_NO_DESCRIPTION')
            
                  }, null, 10, _hoisted_11))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("button", {
        class: "btn btn-lg btn-dark-blue",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickContactUs()))
      }, [
        _createTextVNode(_toDisplayString(_ctx.translate("CONTACT_US_LABEL")) + " ", 1),
        (_openBlock(), _createElementBlock("svg", {
          width: "17",
          height: "16",
          viewBox: "0 0 17 16",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          alt: _ctx.translate('CONTACT_US_LABEL'),
          "aria-hidden": "true"
        }, _hoisted_15, 8, _hoisted_13))
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createTextVNode(_toDisplayString(_ctx.translate("TITLE_SURVEY_PLUS_PIE_RESULT")) + " ", 1),
          _createElementVNode("div", _hoisted_19, [
            _createTextVNode(_toDisplayString(_ctx.translate("TITLE_YEAR")) + " ", 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.current_yearly_period), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.translate("LABEL_NUMBER_OF_COMPANY")) + " :", 1),
        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.compareDetailResult.count), 1)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_ctx.amplitudeGraph.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _createElementVNode("h4", _hoisted_29, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_POLICY")), 1),
                    _createElementVNode("div", null, [
                      _hoisted_30,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_YOUR_COMPANY")) + ": " + _toDisplayString(_ctx.amplitudeGraph[0]) + "% ", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_31,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_AVERAGE_COMPANIES")) + ": " + _toDisplayString(_ctx.amplitudeGraph[1]) + "% ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_apexchart, {
                class: "statistics-widget-3-chart card-rounded-bottom",
                options: _ctx.amplitudeChartOptions,
                series: _ctx.amplitudeGraph,
                type: "radialBar"
              }, null, 8, ["options", "series"]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_DIVERSITY_DETAIL")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_ctx.deffusioneGraph.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("h4", _hoisted_35, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_DIVERSITY")), 1),
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_YOUR_COMPANY")) + ": " + _toDisplayString(_ctx.deffusioneGraph[0]) + "% ", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_37,
                      _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_AVERAGE_COMPANIES")) + ": " + _toDisplayString(_ctx.deffusioneGraph[1]) + "% ", 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_apexchart, {
                class: "statistics-widget-3-chart card-rounded-bottom",
                options: _ctx.deffusioneChartOptions,
                series: _ctx.deffusioneGraph,
                type: "radialBar"
              }, null, 8, ["options", "series"]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_POLICY_DETAIL")), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.translate("SURVEY_PLUS_HOW_TO_READ")), 1),
              _createElementVNode("p", {
                class: "graph1-text text-dark-blue",
                innerHTML: _ctx.translate('SURVEY_PLUS_HOW_TO_READ_DETAIL')
              }, null, 8, _hoisted_42)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_43, [
          (_ctx.selectOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.translate("LABEL_COMPARE_SURVEY_PLUS_CHART")), 1),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.translate("REPORT_SELECT_EMPLOYEES_LABEL")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "employees_range",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.employees_range,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formDataForCompareDetail.employees_range) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_EMPLOYEES_LABEL')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: 0,
                        label: _ctx.translate('REPORT_COMPARISON_ALL_EMPLOYEES_RANGES')
                      }, null, 8, _hoisted_48),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.employee_range, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.range_id,
                          label: item.description,
                          key: index
                        }, null, 8, _hoisted_49))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.translate("REPORT_SELECT_SETTORE_LABEL")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "settori",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.settore,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formDataForCompareDetail.settore) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_SETTORE_LABEL')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: 0,
                        label: _ctx.translate('REPORT_COMPARISON_ALL_SECTORS')
                      }, null, 8, _hoisted_52),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.settori, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          label: item[_ctx.translateKey('descrizione')],
                          key: index
                        }, null, 8, _hoisted_53))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.translate("REPORT_SELECT_FATTURATO_LABEL")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "fatturati",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.fatturato,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formDataForCompareDetail.fatturato) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_FATTURATO_LABEL')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: 0,
                        label: _ctx.translate('REPORT_COMPARISON_ALL_REVENUES')
                      }, null, 8, _hoisted_56),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.fatturati, (item, index) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: item.id,
                          label: item.descrizione,
                          key: index
                        }, null, 8, _hoisted_57))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.translate("REPORT_SELECT_QUOTED_LABEL")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "is_quoted",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.is_quoted,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formDataForCompareDetail.is_quoted) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_QUOTED_LABEL')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: "ALL",
                        label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                      }, null, 8, _hoisted_60),
                      _createElementVNode("option", {
                        value: "YES",
                        label: _ctx.translate('REPORT_COMPARISON_QUOTED_MESSAGE')
                      }, null, 8, _hoisted_61),
                      _createElementVNode("option", {
                        value: "NO",
                        label: _ctx.translate('REPORT_COMPARISON_NOT_QUOTED_MESSAGE')
                      }, null, 8, _hoisted_62)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.translate("REPORT_SELECT_ASSOCIATED_LABEL")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "is_associated",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.is_associated,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formDataForCompareDetail.is_associated) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_ASSOCIATED_LABEL')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: "ALL",
                        label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                      }, null, 8, _hoisted_65),
                      _createElementVNode("option", {
                        value: "YES",
                        label: _ctx.translate('REPORT_COMPARISON_ASSOCIATED_MESSAGE')
                      }, null, 8, _hoisted_66),
                      _createElementVNode("option", {
                        value: "NO",
                        label: _ctx.translate('REPORT_COMPARISON_NOT_ASSOCIATED_MESSAGE')
                      }, null, 8, _hoisted_67)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.translate("REPORT_SELECT_COMPANY_TYPE")), 1),
                  _createVNode(_component_Field, {
                    as: "select",
                    name: "company_type",
                    class: "form-select form-select-solid form-select-lg",
                    modelValue: _ctx.formDataForCompareDetail.company_type,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formDataForCompareDetail.company_type) = $event)),
                    "aria-label": _ctx.translate('REPORT_SELECT_COMPANY_TYPE')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("option", {
                        value: "ALL",
                        label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                      }, null, 8, _hoisted_70),
                      _createElementVNode("option", {
                        value: "D01",
                        label: _ctx.translate('CHANGE_PMI_OPTION')
                      }, null, 8, _hoisted_71),
                      _createElementVNode("option", {
                        value: "D02",
                        label: _ctx.translate('CHANGE_SMALL_OPTION')
                      }, null, 8, _hoisted_72),
                      _createElementVNode("option", {
                        value: "D03",
                        label: _ctx.translate('CHANGE_LARGE_OPTION')
                      }, null, 8, _hoisted_73)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "aria-label"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _hoisted_74,
    _createElementVNode("section", _hoisted_75, [
      _createElementVNode("div", _hoisted_76, [
        _createTextVNode(_toDisplayString(_ctx.translate("TITLE_SURVEY_PLUS_RADAR_RESULT")) + " ", 1),
        _createElementVNode("div", _hoisted_77, [
          _createTextVNode(_toDisplayString(_ctx.translate("TITLE_YEAR")) + " ", 1),
          _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.current_yearly_period), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_79, [
        _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.translate("LABEL_NUMBER_OF_COMPANY")) + " :", 1),
        _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.compareDetailResult.count), 1)
      ]),
      _createElementVNode("div", _hoisted_82, [
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            (_ctx.seriesForGraph2)
              ? (_openBlock(), _createElementBlock("table", _hoisted_85, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_86, [
                      _hoisted_87,
                      _createElementVNode("th", _hoisted_88, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_GENRE")), 1),
                      _createElementVNode("th", _hoisted_89, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_AGE")), 1),
                      _createElementVNode("th", _hoisted_90, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_DISABILIY")), 1),
                      _createElementVNode("th", _hoisted_91, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_CULTURE")), 1),
                      _createElementVNode("th", _hoisted_92, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_BACKGROUND")), 1),
                      _createElementVNode("th", _hoisted_93, _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_SEX")), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_94, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_95, [
                        _hoisted_96,
                        _createTextVNode(" " + _toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_YOUR_COMPANY")), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[0]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[1]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[2]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[3]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[4]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[0].data[5]) + "%", 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_97, [
                        _hoisted_98,
                        _createTextVNode(_toDisplayString(_ctx.translate("SURVEY_PLUS_LABEL_AVERAGE_COMPANIES")), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[0]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[1]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[2]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[3]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[4]) + "%", 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.seriesForGraph2[1].data[5]) + "%", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_apexchart, {
            class: "statistics-widget-3-chart card-rounded-bottom",
            options: _ctx.radarChartOptions,
            series: _ctx.seriesForGraph2,
            type: "radar"
          }, null, 8, ["options", "series"])
        ]),
        _createElementVNode("div", _hoisted_99, [
          _createElementVNode("div", _hoisted_100, [
            (_ctx.selectOptions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                  _createElementVNode("h3", _hoisted_102, _toDisplayString(_ctx.translate("LABEL_COMPARE_SURVEY_PLUS_CHART")), 1),
                  _createElementVNode("div", _hoisted_103, [
                    _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.translate("REPORT_SELECT_EMPLOYEES_LABEL")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "employees_range",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.employees_range,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formDataForCompareDetail.employees_range) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_EMPLOYEES_LABEL')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: 0,
                          label: _ctx.translate('REPORT_COMPARISON_ALL_EMPLOYEES_RANGES')
                        }, null, 8, _hoisted_105),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.employee_range, (item, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.range_id,
                            label: item.description,
                            key: index
                          }, null, 8, _hoisted_106))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ]),
                  _createElementVNode("div", _hoisted_107, [
                    _createElementVNode("label", _hoisted_108, _toDisplayString(_ctx.translate("REPORT_SELECT_SETTORE_LABEL")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "settori",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.settore,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formDataForCompareDetail.settore) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_SETTORE_LABEL')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: 0,
                          label: _ctx.translate('REPORT_COMPARISON_ALL_SECTORS')
                        }, null, 8, _hoisted_109),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.settori, (item, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.id,
                            label: item[_ctx.translateKey('descrizione')],
                            key: index
                          }, null, 8, _hoisted_110))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ]),
                  _createElementVNode("div", _hoisted_111, [
                    _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.translate("REPORT_SELECT_FATTURATO_LABEL")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "fatturati",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.fatturato,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formDataForCompareDetail.fatturato) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_FATTURATO_LABEL')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: 0,
                          label: _ctx.translate('REPORT_COMPARISON_ALL_REVENUES')
                        }, null, 8, _hoisted_113),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectOptions.fatturati, (item, index) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: item.id,
                            label: item.descrizione,
                            key: index
                          }, null, 8, _hoisted_114))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ]),
                  _createElementVNode("div", _hoisted_115, [
                    _createElementVNode("label", _hoisted_116, _toDisplayString(_ctx.translate("REPORT_SELECT_QUOTED_LABEL")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "is_quoted",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.is_quoted,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formDataForCompareDetail.is_quoted) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_QUOTED_LABEL')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: "ALL",
                          label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                        }, null, 8, _hoisted_117),
                        _createElementVNode("option", {
                          value: "YES",
                          label: _ctx.translate('REPORT_COMPARISON_QUOTED_MESSAGE')
                        }, null, 8, _hoisted_118),
                        _createElementVNode("option", {
                          value: "NO",
                          label: _ctx.translate('REPORT_COMPARISON_NOT_QUOTED_MESSAGE')
                        }, null, 8, _hoisted_119)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ]),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("label", _hoisted_121, _toDisplayString(_ctx.translate("REPORT_SELECT_ASSOCIATED_LABEL")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "is_associated",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.is_associated,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formDataForCompareDetail.is_associated) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_ASSOCIATED_LABEL')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: "ALL",
                          label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                        }, null, 8, _hoisted_122),
                        _createElementVNode("option", {
                          value: "YES",
                          label: _ctx.translate('REPORT_COMPARISON_ASSOCIATED_MESSAGE')
                        }, null, 8, _hoisted_123),
                        _createElementVNode("option", {
                          value: "NO",
                          label: _ctx.translate('REPORT_COMPARISON_NOT_ASSOCIATED_MESSAGE')
                        }, null, 8, _hoisted_124)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ]),
                  _createElementVNode("div", _hoisted_125, [
                    _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.translate("REPORT_SELECT_COMPANY_TYPE")), 1),
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "company_type",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.formDataForCompareDetail.company_type,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formDataForCompareDetail.company_type) = $event)),
                      "aria-label": _ctx.translate('REPORT_SELECT_COMPANY_TYPE')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", {
                          value: "ALL",
                          label: _ctx.translate('REPORT_COMPARISON_INDIFFERENT')
                        }, null, 8, _hoisted_127),
                        _createElementVNode("option", {
                          value: "D01",
                          label: _ctx.translate('CHANGE_PMI_OPTION')
                        }, null, 8, _hoisted_128),
                        _createElementVNode("option", {
                          value: "D02",
                          label: _ctx.translate('CHANGE_SMALL_OPTION')
                        }, null, 8, _hoisted_129),
                        _createElementVNode("option", {
                          value: "D03",
                          label: _ctx.translate('CHANGE_LARGE_OPTION')
                        }, null, 8, _hoisted_130)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "aria-label"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}